import { graphql } from '@/gql';
import type { GetSmsTemplateTopicListQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getSmsTemplateTopicList = async ({ smsRecipientName }: GetSmsTemplateTopicListQueryVariables): Promise<string[]> => {
  const response = await queryExecute({
    query: graphql(`
      query GetSmsTemplateTopicList($smsRecipientName: SmsRecipientName!) {
        getSmsTemplateTopicList(smsRecipientName: $smsRecipientName)
      }
    `),
    variables: {
      smsRecipientName,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.getSmsTemplateTopicList;
};
